import React, { useEffect } from 'react';
import HeroSlider from '../components/HeroSlider';
import PresidentMessage from '../components/PresidentMessage';
import StateProfile from '../components/StateProfile';
import MinistriesGrid from '../components/MinistriesGrid';
import NewsSection from '../components/NewsSection';
import InvestmentSection from '../components/InvestmentSection';
import EventsSection from '../components/EventsSection';
import SEO from '../components/SEO';
import { useSiteData } from '../lib/SiteDataContext';

const HomePage = () => {
  const { settings } = useSiteData();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const origin =
    process.env.REACT_APP_PUBLIC_URL ||
    (typeof window !== 'undefined' ? window.location.origin : '');
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'GovernmentOrganization',
    name: settings?.site_name || 'South East State of Somalia — State House',
    url: origin,
    logo: settings?.logo_url ? `${origin}${settings.logo_url}` : undefined,
    description:
      'Official portal of the South East State of Somalia — news, events, ministries, investment opportunities and government services.',
    address: settings?.contact?.address
      ? {
          '@type': 'PostalAddress',
          streetAddress: settings.contact.address,
          addressCountry: 'SO',
        }
      : undefined,
    contactPoint: settings?.contact?.email
      ? {
          '@type': 'ContactPoint',
          email: settings.contact.email,
          telephone: settings?.contact?.phone,
          contactType: 'Government',
        }
      : undefined,
    sameAs: Object.values(settings?.social || {}).filter(Boolean),
  };

  return (
    <>
      <SEO
        title="Home"
        description="Official portal of the South East State of Somalia. Explore the President's office, ministries, news, events, investment opportunities and citizen services."
        jsonLd={jsonLd}
      />
      <HeroSlider />
      <PresidentMessage />
      <StateProfile />
      <MinistriesGrid />
      <NewsSection />
      <InvestmentSection />
      <EventsSection />
    </>
  );
};

export default HomePage;
